import styled from "@emotion/styled";
import Autocomplete from "@mui/material/Autocomplete";

import { fontRoboto, setFullViewportWidthBackgroundStyles, theme } from "shared/lib/styles";
import type { WithStickyStackedHeightProps } from "shared/lib/styles";

import { BaseInput } from "scmp-app/components/common/base-input";

import CloseIcon from "./icon-close.svg";
import iconMagnifier from "./icon-magnifier.svg";

export const Container = styled.div<WithStickyStackedHeightProps>`
  position: sticky;
  inset-block-start: 0;
  z-index: 2;

  padding-block: 12px 28px;
  ${theme.breakpoints.up("tablet")} {
    inset-block-start: ${props => props.$stickyStackedHeight}px;
  }

  & .MuiAutocomplete-listbox {
    max-block-size: 340px;
    padding-block: 12px;
    padding-inline: 0;

    line-height: normal;

    overflow-y: auto;
  }

  && .MuiAutocomplete-option {
    min-block-size: 37px;
    padding-block: 8px;
    padding-inline: 20px;

    font-size: 18px;
  }
`;

export const FullWidthBackground = styled.div`
  ${setFullViewportWidthBackgroundStyles("#ffffff")}
`;

export const StyledBaseInput = styled(BaseInput)`
  border-block-end: 1px solid #000000;

  padding-block-end: 12px;
`;

export const StyledInput = styled.input`
  flex-grow: 1;

  inline-size: 100%;

  color: #000000;
  font-weight: 300;
  font-size: 24px;
  font-family: ${fontRoboto};
  line-height: 28px;

  outline: 0;

  appearance: none;

  ${theme.breakpoints.up("desktop")} {
    font-weight: 300;
    font-size: 48px;
    font-family: ${fontRoboto};
    line-height: 58px;
  }
`;

export const StyledInputAdornment = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  align-items: center;

  inline-size: 32px;
  block-size: 32px;
  padding-block-end: 4px;
  padding-inline-end: 3px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 72px;
    block-size: 72px;
    padding: 12px;
  }
`;

export const StyledClose = styled(CloseIcon)`
  inline-size: 12px;
  block-size: 12px;

  cursor: pointer;

  fill: #4585ff;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 24px;
    block-size: 24px;
  }
`;

export const StyledMagnifier = styled(iconMagnifier)`
  inline-size: 18px;
  block-size: 18px;

  cursor: pointer;

  fill: #4585ff;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 48px;
    block-size: 48px;
  }
`;

export const StyledAutocomplete = styled(Autocomplete)`
  && .MuiAutocomplete-inputRoot {
    padding-inline: 0;
  }
`;
